var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66663 10.9999H3.99996V12.3333H12V1.66659H3.99996V2.99992H2.66663V0.999919C2.66663 0.823108 2.73686 0.653538 2.86189 0.528514C2.98691 0.40349 3.15648 0.333252 3.33329 0.333252H12.6666C12.8434 0.333252 13.013 0.40349 13.138 0.528514C13.2631 0.653538 13.3333 0.823108 13.3333 0.999919V12.9999C13.3333 13.1767 13.2631 13.3463 13.138 13.4713C13.013 13.5963 12.8434 13.6666 12.6666 13.6666H3.33329C3.15648 13.6666 2.98691 13.5963 2.86189 13.4713C2.73686 13.3463 2.66663 13.1767 2.66663 12.9999V10.9999ZM3.99996 6.33325H8.66663V7.66659H3.99996V9.66659L0.666626 6.99992L3.99996 4.33325V6.33325Z",
    fill: "#ED1D25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.d60fcb0b6426a663547feb1155d0dd66.svg";
export { ForwardRef as ReactComponent };